(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('DistinctionSummaryReportController', DistinctionSummaryReportController);

	DistinctionSummaryReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function DistinctionSummaryReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			types: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		self.title = $state.current.data.title;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine Types',
							'Wines',
							'% Wines in Cellar',
							'Bottles',
							'% Bottles in Cellar',
							'Producers',
							'Varietals',
							'Countries',
							'Full body wines',
							'Medium body wines',
							'Light body wines',
							'Wine body not set'
						];

						// add only those in the cellar
						lodash.forEach(wineEntities, function(wine) {
							if (wine.cellar.qty > 0) {
								self.wines.push(wine);
							}
						});

						var totalWines = self.wines.length;

						var totalBottles = WineRepository.getTotalCellarBottleCount(wineEntities);

						var winesGrouped = lodash.groupBy(self.wines, function(w) {
							return (w.distinction && w.distinction.name) ? w.distinction.name : '<em>Unknown</em>';
						});

						// initialize totals
						var totals = {
							wines:  0,
							bottles: 0,
						};

						var bodyOrder = ['Full', 'Medium', 'Light', 'No body'];

						lodash.forEach(bodyOrder, function(body) {
							totals[body] = 0;
						});

						lodash.forEach(winesGrouped, function(wines, type) {
							var totalTypeCount = wines.length;

							// add wines to grand total
							totals.wines += totalTypeCount;

							// count bottles, start at 0
							var totalTypeBottles = lodash.reduce(wines, function(total, wine) {
								return total + lodash.parseInt(wine.cellar.qty);
							}, 0);

							// add bottles to grand total
							totals.bottles += totalTypeBottles;

							var producers = lodash.unique(lodash.pluck(wines, 'producer.name'));
							var varietals = lodash.unique(lodash.pluck(wines, 'varietal.name'));
							var countries = lodash.unique(lodash.pluck(wines, 'region.country'));

							var summary = {
								"Wines": totalTypeCount,
								"% Wines in Cellar": $window.numeral(totalTypeCount / totalWines).format('0.00%'),
								"Producers": producers.length,
								"Varietals": varietals.length,
								"Countries": countries.length
							};

							// group by body so you can get cound easily
							var winesByBody = lodash.groupBy(wines, function(wine) {
								return (wine.body) ? wine.body : '';
							});

							// append to summary Obj.
							// update grand totals
							lodash.forEach(bodyOrder, function(bodyName) {
								var total = (winesByBody[bodyName]) ? winesByBody[bodyName].length : 0;

								// append body to summary
								summary[bodyName] = total;

								if (lodash.has(totals, bodyName)) {
									// body total exists, update it
									totals[bodyName] += total;
								} else {
									// no body total yet, create it
									totals[bodyName] = total;
								}
							});

							// put bottles at the end b/c everything else is based on wines (having bottles between
							// wines and bodies seemed confusing)
							summary.Bottles = totalTypeBottles;
							summary["% Bottles in Cellar"] = $window.numeral(totalTypeBottles / totalBottles).format('0.00%');

							var tableSummary = [
								summary['Wines'],
								summary['% Wines in Cellar'],
								summary['Bottles'],
								summary['% Bottles in Cellar'],
								summary['Producers'],
								summary['Varietals'],
								summary['Countries'],
								summary['Full'],
								summary['Medium'],
								summary['Light'],
								summary['No body']
							];

							self.report.types.push({ type: type, summary: tableSummary });

						});

						// sort by type name
						self.report.types = lodash.sortBy(self.report.types, function(type) {
							return type.type;
						});

						self.report.totals = [
							// 'Wine Types',
							'Totals',
							// 'Wines',
							totals.wines,
							// '% Wines in Cellar',
							null,
							// 'Bottles',
							totalBottles,
							// '% Bottles in Cellar'
							null,
							// 'Producers',
							null,
							// 'Varietals',
							null,
							// 'Countries',
							null,
							// 'Full body wines',
							totals['Full'],
							// 'Medium body wines',
							totals['Medium'],
							// 'Light body wines',
							totals['Light'],
							// 'Wine body not set',
							totals['No body']
						];

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});

		}

		function print(){
			return $window.print();
		}
	}

})();
